import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { AiFillGithub } from 'react-icons/ai';
import { FaRegPaperPlane } from 'react-icons/fa';

const NSinglePortfolio = ({ project }) => {
     const { id, title, image, discription, features, technologies, liveLink, frontendLink, backendLink } = project
    const imageStyle={
        backgroundImage: `url(${image})`,
        backgroundSize:"cover",
        height:"201px"
    }
   
    const fixDetails = discription.slice(0, 150)
    const Ntechnologies = technologies.slice(0, 6)
    return (
        <Col md={4} className='my-3'>
            <div className="singlePortfolio ">
                <div className="portfolioImage">
                    <div style={imageStyle} className="imagescroll">
                        {/* <img className='w-100' src={image} alt="" /> */}
                    </div>
                </div>
                <div className="portfolioDetail ">
                    <h4 className="project-title">{title}</h4>
                    <p className='mb-2 project-detail'><small>{discription}</small></p>
                    {/* <ul className="portfolio-tecgnology project-tecgnology ">
                        {
                            Ntechnologies.map(st => <li>{st}</li>)
                        }
                    </ul> */}
                    <div align="center" className="project-icons mb-1">
                        <Button target="_blank" href={frontendLink}><AiFillGithub className="portfolio-icon" /></Button>
                        <Button target="_blank" href={liveLink}><FaRegPaperPlane color='red' className="portfolio-icon" /></Button>
                    </div>
                    <div className="project-title-icon">
                        <Row >
                            <Col md={8} className="p-2">
                                <h6>{title}</h6>
                            </Col>
                            <Col md={4} className="p-0">
                                <a className='p-1' target="_blank" href={frontendLink}><AiFillGithub color='#64ffda' /></a>
                                <a className='p-1' target="_blank" href={liveLink}><FaRegPaperPlane color='#64ffda' /></a>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        </Col>
    );
};

export default NSinglePortfolio;